import cookieManager from "../../../components/CookieManager";
import TriggerActionService from "../../../components/TriggerActionService";
import ActionTriggerConstants from "../../../components/ActionTriggerConstants";
import Localize from "../../../components/Localize/Localize";
import BrazeService from "../../../components/BrazeService";

const getIframeWindow = () => document.getElementById("game-iframe")?.contentWindow;

let lastReportedPct = -1;

const UnityBridge = {
    handleAction(action, data) {
        switch (action) {
            case "unityProgress":
                UnityBridge.reportUnityProgress(data);
                break;
            case "setUserID":
                UnityBridge.setUserID(data);
                break;
            case "getCookie":
                UnityBridge.getCookie(data);
                break;
            case "setCookie":
                UnityBridge.setCookie(data);
                break;
            case "deleteCookie":
                UnityBridge.deleteCookie(data);
                break;
            case "getCurrentURL":
                UnityBridge.sendCurrentURL(data);
                break;
            case "getCurrentUserAgent":
                UnityBridge.sendUserAgent(data);
                break;
            case "onUnityLoaded":
                UnityBridge.onUnityLoaded();
                break;
            case "copyToClipboard":
                UnityBridge.copyToClipboard(data);
                break;
            case "closeCheckoutIframe":
                UnityBridge.onCheckoutIframeClose();
                break;
            case "SetLanguageCookie":
                UnityBridge.setCookie(data);
                UnityBridge.SetLanguage(data);
                break;
            case "onUnitySuccess":
                UnityBridge.onUnitySuccess();
                break;
            case "onUnityError":
                UnityBridge.onUnityError(data);
                break;
            case "brazeChangeUser":
                BrazeService.changeUser(data.parameter);
                break;
            case "brazeLogCustomEvent":
                BrazeService.logCustomEvent(data.eventName, data.properties || {});
                break;
            case "brazeLogPurchase":
                BrazeService.logPurchase(data.productId, data.price, data.currency, data.quantity, data.properties || {});
                break;
            case "brazeSetUserAttribute":
                BrazeService.setUserAttribute(data.key, data.value);
                break;
            case "brazeSetEmail":
                BrazeService.setEmail(data.value);
                break;
            case "brazeRequestPush":
                BrazeService.requestPushPermission();
                break;
            default:
                console.warn(`[UnityBridge] Unknown action: ${action}`);
        }
    },

    setUserID({ parameter }) {
        console.log(`[UnityBridge] Setting User ID: ${parameter}`);
        if (typeof window.AF === "function") {
            window.AF("pba", "setCustomerUserId", parameter);
        } else {
            console.warn("AppsFlyer SDK not initialized.");
        }
    },

    getCookie({ parameter, idTask }) {
        const value = cookieManager.get(parameter) || "";
        const iframe = getIframeWindow();

        if (!value) {
            console.warn(`[UnityBridge] Cookie NOT found with key: ${parameter}`);
        } else {
            console.log(`[UnityBridge] Cookie found: ${parameter} = ${value}`);
        }

        iframe?.postMessage({ action: "sendCookie", value, idTask }, "*");

        UnityBridge.tryTriggerReplayOrDeeplink(iframe);
    },

    setCookie({ key, value, days }) {
        const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
        cookieManager.set(key, value, {
            expires,
            sameSite: "None",
            secure: true,
        });
        console.log(`[UnityBridge] Set cookie: ${key} = ${value}`);
    },

    deleteCookie({ key }) {
        cookieManager.remove(key);
        console.log(`[UnityBridge] Deleted cookie: ${key}`);
    },

    sendCurrentURL({ idTask }) {
        const iframe = getIframeWindow();
        const url = window.location.href;
        console.log(`[UnityBridge] Sending current URL: ${url}`);
        iframe?.postMessage({ action: "sendCurrentURL", value: url, idTask }, "*");
    },

    sendUserAgent({ idTask }) {
        const iframe = getIframeWindow();
        const userAgent = navigator.userAgent;
        console.log(`[UnityBridge] Sending user agent: ${userAgent}`);
        iframe?.postMessage({ action: "sendCurrentUserAgent", value: userAgent, idTask }, "*");
    },

    onUnityLoaded() {
        console.log("[UnityBridge] Unity loaded trigger received");
        TriggerActionService.sendTriggerAction(ActionTriggerConstants.UNITY_LOAD_ENDED, "", {
            sourceUrl: "Game"
        }).catch((e) => {
            console.warn("[UnityBridge] TriggerActionService failed", e);
        });
    },

    onUnitySuccess() {
        console.log("[UnityBridge] Unity Success trigger received");
        TriggerActionService.sendTriggerAction(ActionTriggerConstants.UNITY_LOAD_SUCCESS, "", {
            sourceUrl: "Game"
        }).catch((e) => {
            console.warn("[UnityBridge] TriggerActionService failed", e);
        });
    },

    onUnityError({ value }) {
        console.log(`[UnityBridge] Unity ERROR trigger received: ${value}`);

        TriggerActionService.sendTriggerAction(
            ActionTriggerConstants.UNITY_LOAD_ERROR,
            "",
            { sourceUrl: "Game", message: value.ToString() }
        ).catch((e) => {
            console.warn("[UnityBridge] TriggerActionService failed", e);
        });
    },

    copyToClipboard({ value }) {
        navigator.clipboard.writeText(value)
            .then(() => console.log("[Game] Copied to clipboard successfully:", value))
            .catch((err) => console.warn("[Game] Clipboard copy failed:", err));
    },

    tryTriggerReplayOrDeeplink(iframe) {
        const params = new URLSearchParams(window.location.search);
        const replay = params.get("replay");
        const deeplink = params.get("triggerDeepLink");

        if (replay) {
            console.log(`[UnityBridge] Triggering Replay: ${replay}`);
            iframe?.postMessage({ action: "replay", value: replay }, "*");
        }

        if (deeplink) {
            console.log(`[UnityBridge] Triggering DeepLink: ${deeplink}`);
            iframe?.postMessage({ action: "triggerDeepLink", value: deeplink }, "*");
        }

        if (replay || deeplink) {
            params.delete("replay");
            params.delete("triggerDeepLink");
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState({}, "", newUrl);
        }
    },

    onCheckoutIframeClose() {
        const iframe = getIframeWindow();
        iframe?.postMessage({ action: "onCheckoutIframeClose" }, "*");
    },

    SetLanguage({ key, lng, days }){        
        Localize.setLanguage(lng);
        console.log(`[UnityBridge] SetLanguageCookie: ${lng}`);
    },

    reportUnityProgress({ value }) {
        if (value === lastReportedPct) return;
        lastReportedPct = value;
        console.log(`[UnityBridge] ReportUnityProgress: ${value}`);

        const action = `${ActionTriggerConstants.UNITY_LOAD_PROGRESS}${value}`;
        TriggerActionService.sendTriggerAction(action.toString(), "", {
            sourceUrl: "Game"
        }).catch((e) => {
            console.warn("[UnityBridge] TriggerActionService failed", e);
        });
    }
};

export default UnityBridge;
